const ProfileData = {
  img: require("../assets/Images/hero.png"),
  logo: require("../assets/Images/Name.png"),
  name: "Vijay Kumar",
  professions: ["Web Developer", "Free Lancer", "Enthusiastic Dev"],
  info: [
    "Knack of building web applications using MERN stack.",
    "I enjoy designing tech websites.",
  ],
  resume:
    "https://drive.google.com/drive/u/1/folders/1VLbE3u0gC3x66ClPWCUmcK75DuhTAyKx",
};

export default ProfileData;
